module.exports = __webpack_public_path__ + "img/pdf.d2563019.png";